import { persianLanguage } from "../../../constants/persianTerms"

export const generalErrorMessage = (status) => {
    if ( status === 400){
        return persianLanguage.phrase.error.ERROR_400;
    } else if(status === 401){
        return persianLanguage.phrase.error.ERROR_401;
    } else if(status === 403){
        return persianLanguage.phrase.error.ERROR_403;
    } else if(status === 404){
        return persianLanguage.phrase.error.ERROR_404;
    } else if(status === 406){
        return persianLanguage.phrase.error.ERROR_406;
    } else if(status === 409){
        return persianLanguage.phrase.error.ERROR_409;
    } else if(status === 429){
        return persianLanguage.phrase.error.ERROR_429;
    } else if(status === 500){
        return persianLanguage.phrase.error.ERROR_500;
    }
    
}

export const generalSuccessMessage = (status) => {
    if ( status === 200){
        return persianLanguage.phrase.success.SUCCESS_200;
    }
    
}

